import { render, staticRenderFns } from "./client-dialog-coordinate-dialog.vue?vue&type=template&id=cd260976&scoped=true"
import script from "./client-dialog-coordinate-dialog.vue?vue&type=script&lang=js"
export * from "./client-dialog-coordinate-dialog.vue?vue&type=script&lang=js"
import style0 from "./client-dialog-coordinate-dialog.vue?vue&type=style&index=0&id=cd260976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd260976",
  null
  
)

export default component.exports